import React from "react";

// components
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Navbar,
  Nav,
  Container,
  Media
} from "reactstrap";

import { setObjectCookie_Generic, getSessionCookie } from "../../services/session.js";
import routes from "../../routes.jsx";

//Components
import AlertasVisualizacoes from "../../components/AlertasVisualizacoes/index.jsx";

//Context
import { AlertasContext } from "../../context/AlertasContext.jsx";

class AdminNavbar extends React.Component {
  static contextType = AlertasContext;

  constructor(props) {
    super(props);
    this.state = {
      value: '',
      nomeUsuario: getSessionCookie()?.nome || "",
      icon: ""
    };
    this.handleEnter = this.handleEnter.bind(this);
  }

  handleEnter = (e) => {
    if (e.key === "Enter") {
      if (e.target.value !== "") {
        setObjectCookie_Generic("ordem_servico", e.target.value);
      } else {
        setObjectCookie_Generic("ordem_servico", "*");
      }
      this.setState({ value: "" });
    }
  };

  LogOut = () => {
    const { history } = this.props;
    const { setAlertas, setPermissaoExibirAlerta } = this.context;

    setAlertas([]);
    setPermissaoExibirAlerta(false);

    history.push('/auth/login');
  };

  Setup = () => {
    const { history } = this.props;
    history.push('/admin/setup');
  };

  TrocarSenha = () => {
    const { history } = this.props;
    history.push('/admin/trocarsenha');
  };

  render() {
    const _name_route = this.props.brandText;

    return (
      <>
        <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
          <Container fluid>
            <span className="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block">
              <i className={routes.find(n => n.name === _name_route)?.icon}></i>
              &nbsp;
              {this.props.brandText}
            </span>

            <Nav className="align-items-center d-none d-md-flex ml-auto" navbar>
              <AlertasVisualizacoes />
              <UncontrolledDropdown nav>
                <DropdownToggle className="p-0" nav>
                  <Media className="align-items-center">
                    <Media className=" d-none d-lg-block">
                      <span className="mb-0 text-sm font-weight-bold">
                        {this.state.nomeUsuario}
                      </span>
                      &nbsp;
                      <i className="fa fa-chevron-circle-down" aria-hidden="true" />
                    </Media>
                  </Media>
                </DropdownToggle>

                <DropdownMenu className="dropdown-menu-arrow" right>
                  <DropdownItem className="noti-title" header tag="div">
                    <h6 className="text-overflow m-0">Bem Vindo!</h6>
                  </DropdownItem>

                  <DropdownItem onClick={this.TrocarSenha}>
                    <i className="ni ni-lock-circle-open" />
                    <span>Trocar Senha</span>
                  </DropdownItem>

                  <DropdownItem divider />

                  <DropdownItem onClick={this.LogOut}>
                    <i className="ni ni-user-run" />
                    <span>Logout</span>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Container>
        </Navbar>
      </>
    );
  }
}

export default AdminNavbar;
